import React, { useState, useEffect, Suspense } from "react";
import { raiseGetRequest } from './AxiosAPI';

export function sleep(time){
  new Promise((resolve) => setTimeout(resolve, Math.ceil(time * 1000)));
}


export async function crackersCategories() {
    const response = await fetch("/v1/crackers/categories");
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
}

export function isXSmScreen(width) {
  if(width && width < 576) {
    return true;
  }
  return false;
}

export function isSmScreen(width) {
  if(width && width >= 576 && width < 768) {
    return true;
  }
  return false;
}

export function isMdScreen(width) {
  if(width && width >= 768 && width <992) {
    return true;
  }
  return false;
}

export function isLgScreen(width) {
  if(width && width >= 992 && width <1200) {
    return true;
  }
  return false;
}

export function isXlScreen(width) {
  if(width && width >= 1200 && width <1400) {
    return true;
  }
  return false;
}

export function isXxlScreen(width) {
  if(width && width >= 1400) {
    return true;
  }
  return false;
}

export function isSmallTouchScreen(width) {
  if(isXSmScreen(width) || isSmScreen(width) || isMdScreen(width)) {
    // if('ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0) {
      return true;
    // }
  }
  return false;
}

export function queryString(query) {
  var params = "";
  query.forEach((value, key) => {
    params += key + "=" + value + "&";
  })
  return params.substring(0, params.length - 1);
}

export function isValidEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export function isValidMobileNumber(mobNumber) {
  return /^\d{10}$/.test(mobNumber);
}

export function isValidPassword(password) {
  if(password.length < 8) {
    return "Password must be at least 8 characters";
  }
  if(password.length > 16) {
    return "Password must be maximum of 16 characters";;
  }

  const regex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*_+\-=?])[A-Za-z\d!@#$%^&*_+\-=?]{8,16}$/;
  return regex.test(password) ? "success" : "Invalid pattern";
}

const controlKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Tab'];

export function numericInputOnly(event) {
  const { key, keyCode } = event;
  const isControlKey = controlKeys.includes(key);
  const isNumericKey = (keyCode >= 48 && keyCode <= 57) || (keyCode >= 96 && keyCode <= 105);
  if (!isNumericKey && !isControlKey) {
      event.preventDefault();
  }
}

export function validateAlphanumeric(event) {
  const { key, keyCode } = event;
  const isControlKey = controlKeys.includes(key);
  const isValidKey = ((keyCode >= 48 && keyCode <= 57)  || (keyCode >= 96 && keyCode <= 105) || (keyCode >= 65 && keyCode <= 90) || (keyCode >= 97 && keyCode <= 122));
  if (!isValidKey && !isControlKey) {
    event.preventDefault();
  }
}

export function dateTimeConverter(millis) {

  var currentdate = new Date(millis);
  var startedAt = currentdate.getFullYear() + "-" +
    (currentdate.getMonth() + 1).toString().padStart(2, '0') + "-" +
    currentdate.getDate().toString().padStart(2, '0') + " " +
    currentdate.getHours().toString().padStart(2, '0') + ":" +
    currentdate.getMinutes().toString().padStart(2, '0');
    // currentdate.getSeconds().toString().padStart(2, '0');
  return startedAt;
}

export function costOfCracker (crackersList, crackerId) {
  let numberOfPages = crackersList["number_of_page"];
  for(let i=1; i<=numberOfPages; i++) {
    for(let j=0; crackersList[i][j] !== undefined; j++) {
      let crackers = crackersList[i][j]["crackers"];
      for(let k=0; k<crackers.length; k++) {
        if(crackers[k]["id"] === crackerId) {
          if(crackers[k]["stock_status"] === 1) {
            return crackers[k]["offer_price"];
          } else {
            return (crackers[k]["offer_price"] * -1);
          }
        }
      }
    }
  }
  return 0;
}

export async function isAdmin() {
  debugger
  const response = await raiseGetRequest(`/customer`, null, null, null);
  if (response) {
    return response.isAdmin;
  }
  return false;
}